// ANT Modules
import { Collapse, Table } from "antd";

export type CollapsiblePanelProps = {
	header: React.ReactNode;
	columns: Array<any>;
	data: Array<any>;
};

const CollapsiblePanel = ({ header, columns, data }: CollapsiblePanelProps): JSX.Element => {
	return (
		<div className="collapsible_panel">
			<Collapse bordered={false}>
				<Collapse.Panel key="panel-1" header={header}>
					<Table columns={columns} dataSource={data} pagination={false} scroll={{ x: true }} />
				</Collapse.Panel>
			</Collapse>
		</div>
	);
};

export default CollapsiblePanel;
